<template>
  <SustainabilityPage
    :market="market"
    :initial-fields="initialFields"
    :hero-image="SUSTAINABILITY_HERO_IMAGE"
    :brochure-file-info="brochureFileInfo"
  >
    <NuxtPage
      :market="market"
      :initial-fields="initialFields"
      :subscription="subscription"
    />
  </SustainabilityPage>
</template>

<script setup lang="ts">
import SustainabilityPage from '~/components/market/SustainabilityPage.vue'
import { ESG, NATURAL_GRAPHITE, MARKET } from '~/constants/services/constants'
import { ESG_NATURAL_GRAPHITE } from '~/constants/services/esg'
import {
  BROCHURE_FILE_INFO,
  SUSTAINABILITY_HERO_IMAGE,
} from '~/src/constants/sustainability'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  layout: 'services',
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const market = NATURAL_GRAPHITE
const initialFields = [market.slug, ESG.checkbox]
const subscription = ESG_NATURAL_GRAPHITE.subscription

const { $config } = useNuxtApp()
const BROCHURE_ENV_KEY = BROCHURE_FILE_INFO[market.slug].EnvKey

const brochureFileInfo = {
  ...BROCHURE_FILE_INFO[market.slug],
  ID: $config.public[BROCHURE_ENV_KEY],
}

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${market.name} Sustainability`,
})
useHead(seo)
</script>
